import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { IMAGES, LINKS } from '../data/site';
export function Craftsmanship() {
  return <section aria-labelledby="craft-heading" className="w-full bg-white" data-id="element-15" data-mp="21p3o7n239twu">
      <div className="mx-auto grid max-w-shell grid-cols-1 gap-10 px-[18px] py-12 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:items-center lg:gap-16 lg:py-20" data-id="element-16" data-mp="1nosyincimld9">
        <div data-id="element-17" data-mp="1sooz0cm07uo2">
          <h2 id="craft-heading" className="text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-18" data-mp="2gcosvlem416v">
            Local Experience. Glass Made To Fit.
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-kosin-body" data-id="element-19" data-mp="26neyu007k8g4">
            Kosin’s Glass has been family-owned since 2000. We give honest
            repair-versus-replacement advice first, then handle exact
            measurement, fabrication and professional installation for homes and
            businesses across Southeast Michigan.
          </p>

          <div className="mt-8 divide-y divide-kosin-line border-y border-kosin-line" data-id="element-20" data-mp="343u39l1sa19s">
            <div className="py-5" data-id="element-21" data-mp="2ifo4fg9nyc16">
              <h3 className="text-[18px] font-semibold text-kosin-charcoal" data-id="element-22" data-mp="2egozhvnxmf9q">
                Keep The Frame. Replace The Glass.
              </h3>
              <p className="mt-2 text-[16px] leading-relaxed text-kosin-body" data-id="element-23" data-mp="2s8v3ykhq2xtc">
                When residential frames are sound, replacing just the glass or
                insulated unit may be a practical alternative to a new window.
              </p>
              <a href={LINKS.residential} className="mt-2.5 inline-flex items-center gap-1.5 text-[15px] font-semibold text-kosin-red hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-24" data-mp="2x76hp6b51sgu">
                Residential glass options
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="1grvdluexqt1y" />
              </a>
            </div>
            <div className="py-5" data-id="element-26" data-mp="1bttz7msgfhwt">
              <h3 className="text-[18px] font-semibold text-kosin-charcoal" data-id="element-27" data-mp="1buv8blpwtubw">
                Windshield Replacement + ADAS In One Place.
              </h3>
              <p className="mt-2 text-[16px] leading-relaxed text-kosin-body" data-id="element-28" data-mp="3gu4nli1vevkw">
                Our certified technicians replace the glass and complete
                on-site ADAS calibration when your vehicle requires it. Auto
                glass installation carries a lifetime vehicle-glass workmanship
                warranty.
              </p>
              <a href={LINKS.adas} className="mt-2.5 inline-flex items-center gap-1.5 text-[15px] font-semibold text-kosin-red hover:text-kosin-bright transition-colors duration-150 ease-kosin" data-id="element-29" data-mp="3uu5r759ish42">
                About ADAS calibration
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-30" data-mp="ddeeguazs2ez" />
              </a>
            </div>
          </div>
        </div>

        <img src={IMAGES.showerAlt} alt="Custom measured glass shower enclosure installed in a finished bathroom" className="aspect-[4/5] w-full rounded object-cover sm:aspect-[4/3] lg:aspect-[4/5]" loading="lazy" data-id="element-31" data-mp="hdojo4qymoss" />
      </div>
    </section>;
}